export function StatCard({ title, value, change, trend, icon: Icon, iconColor }) {
  const iconColorMap = {
    'bg-blue-500': '#3b82f6',
    'bg-green-500': '#10b981',
    'bg-purple-500': '#a855f7',
  };

  const bgColor = iconColorMap[iconColor] || '#3b82f6';

  return (
    <div style={{
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
      transition: 'box-shadow 0.2s',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      }}>
        <div style={{ flex: 1 }}>
          <p style={{
            color: '#666',
            fontSize: '14px',
            fontWeight: '500',
          }}>
            {title}
          </p>
          <p style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#111',
            marginTop: '8px',
          }}>
            {value}
          </p>
          <p style={{
            fontSize: '14px',
            fontWeight: '500',
            marginTop: '8px',
            color: trend === 'up' ? '#16a34a' : '#dc2626',
          }}>
            {trend === 'up' ? '↑' : '↓'} {change}
          </p>
        </div>
        <div style={{
          backgroundColor: bgColor,
          padding: '12px',
          borderRadius: '8px',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Icon size={24} />
        </div>
      </div>
    </div>
  );
}
